import { createUseStyles } from "react-jss";
import {colors} from "../../../constants/colors";

const styles = createUseStyles({
  wrapper: {
    "& #textLoader": {
      marginTop: "100px"
    }
  },
  title: {
    color: colors.lightBlack,
    fontWeight: "600",
    fontSize: "30px",
    lineHeight: "38px",
    padding: "0px",
    margin: "0px",
  },
  subtitle: {
    color: colors.mediumGrey,
    fontWeight: "400",
    fontSize: "16px",
    lineHeight: "24px",
    padding: "0px",
    marginTop: "4px",
    marginBottom: "24px"
  },
  container:{
    maxWidth:"100%",
  }
});

export default styles;
